export const appBaseUrl = 'https://baitalkhairapi.azurewebsites.net'
//export const appBaseUrl = 'https://localhost:44383'